import React from 'react';
import { useSelector } from 'react-redux';
import { useAppSelector } from '../../hooks/use-app-selector';
import { PromoteKlarna } from './PromoteKlarna';
import { getCookie } from '../../utils/cookies';
import { keys as queryKeys } from '../../queries';
import { useGlobals } from '../../globals-context';
import { useFetchSubPaymentMethodsV2 } from '../../shared/hooks/payments';

// TODO:max I think the local type here is not accurate or it was not accurately typed in the past. I updated it to match type of currentMerchant
export interface Merchant {
  id: string | null;
  whiteLabel?: string | null;
  createdAt: string | null;
  currency?: string | null;
  subscriptionStatus?: string;
}

interface Account {
  isKeyAccount?: boolean | null;
}

const EUROPEAN_CURRENCIES = new Set([
  'CHF',
  'CZK',
  'DKK',
  'EUR',
  'GBP',
  'HUF',
  'NOK',
  'PLN',
  'RON',
  'SEK',
]);

function isBannerVisible(): boolean {
  const showBannerCookie = getCookie('showPromoteKlarna');

  if (showBannerCookie !== null) {
    return showBannerCookie === 'true';
  }

  return true;
}

function isEligibleForPromotion(
  currentAccount: Account,
  currentMerchant: Merchant,
  queryClient: any
): boolean {
  const isWhitelabel =
    currentMerchant.whiteLabel !== null &&
    currentMerchant.whiteLabel !== 'shore';

  const isKeyAccount = Boolean(currentAccount?.isKeyAccount);

  const currency = currentMerchant.currency?.toUpperCase();
  const isMerchantFromEurope = currency
    ? EUROPEAN_CURRENCIES.has(currency)
    : false;

  const hasPaidSubscription = currentMerchant.subscriptionStatus === 'active';

  /* eslint-disable prettier/prettier */
  const hasChargebeeSubscription = Boolean(
    currentMerchant.id &&
    queryClient?.getQueryData(
      queryKeys?.subscription.latest(currentMerchant?.id)
    )
  );
  /* eslint-enable prettier/prettier */

  return (
    !isWhitelabel &&
    !isKeyAccount &&
    isMerchantFromEurope &&
    hasPaidSubscription &&
    hasChargebeeSubscription
  );
}

interface IShouldShowPromoteModal {
  currentAccount: Account;
  currentMerchant: Merchant;
  queryClient: any;
  isPaymentMethodsLoading: boolean;
  isKlarnaAlreadyEnabled: boolean;
}

function shouldShowPromoteModal({
  currentAccount,
  currentMerchant,
  queryClient,
  isPaymentMethodsLoading,
  isKlarnaAlreadyEnabled,
}: IShouldShowPromoteModal): boolean {
  try {
    return (
      !isPaymentMethodsLoading &&
      !isKlarnaAlreadyEnabled &&
      isBannerVisible() &&
      isEligibleForPromotion(currentAccount, currentMerchant, queryClient)
    );
  } catch (error) {
    console.error('Error in fetching data to show promotion banner:', error);
    return false;
  }
}

export function Banners() {
  const { queryClient } = useGlobals() as any;
  const currentAccount = useSelector((state: any) => state.currentAccount);
  const currentMerchant = useAppSelector((state) => state.currentMerchant);
  const merchantId = currentMerchant.id ?? '';

  const { data: subPaymentMethods, isLoading: isPaymentMethodsLoading } =
    useFetchSubPaymentMethodsV2(merchantId, Boolean(merchantId));

  const isKlarnaAlreadyEnabled = subPaymentMethods.some(
    (m) => m.name === 'Klarna' && m.enabled
  );

  return (
    <div>
      {shouldShowPromoteModal({
        currentAccount,
        currentMerchant,
        queryClient,
        isPaymentMethodsLoading,
        isKlarnaAlreadyEnabled,
      }) && <PromoteKlarna />}
    </div>
  );
}
